var e="spreadSheetAdapter";export{e as S};
